<template>
<div style="background:#eee">
<v-app
      id="ui"
      class="pa-1"
      style="background:#eee"
      fluid
      app
      tag="section" 
    >
      <v-overlay
        :absolute="false"
        :opacity="0.45"
        :value="isLoading"
        :z-index="3939938498494989"
      >
        <v-skeleton-loader
          :transition="'scale-transition'"
          height="94"
          width="350"
          type="list-item"
          class="loader"
        ></v-skeleton-loader>
      </v-overlay>

      <v-container id="green lighten-3" fluid tag="section">
        <v-toolbar light color="white"> 
          <br>
          <br>
          <br> 
          <br>
          <v-row class="pt-4"> 
            <v-col cols="2"> 
              <h4 class="font-weight-light"> {{ selected_object.length== 0? ' No Assets' : asset_name }} </h4>
            </v-col>
          </v-row>   
        </v-toolbar>   

        <v-tabs color="orange" v-model="tabs">
          <br />
          <v-tabs-slider></v-tabs-slider> 

           <v-tab href="#dashboard" @click="page=1">
            <v-icon>mdi-view-dashboard-outline</v-icon>
            <small class="px-3">Dashboard</small>
          </v-tab>

           <v-tab href="#movements" @click="page=1">
            <v-icon>mdi-road-variant</v-icon>
            <small class="px-3">Full Movement</small>
          </v-tab> 

          <v-tab href="#alerts" @click="page=1">
            <v-icon>mdi-alert-remove-outline</v-icon>
            <small class="px-3">Alerts / Violations</small>
          </v-tab>

         
          <v-tab href="#stops" @click="page=1">
            <v-icon>mdi-car-brake-parking</v-icon>
            <small class="px-3">Stoppages</small>
          </v-tab>

          <v-tab href="#mileage" @click="page=1">
            <v-icon>mdi-map-marker-distance</v-icon>
            <small class="px-3">Mileage</small>
          </v-tab>

          <v-tab href="#fuel" @click="page=1">
            <v-icon>mdi-fuel</v-icon>
            <small class="px-3">Fuel</small>
          </v-tab>   

          <v-spacer></v-spacer>
          <v-tab :href="'#'+tabs" @click="initDownload(tabs)"> 
            <v-icon>mdi-file-download-outline</v-icon>
            <small class="px-3">{{downloading? 'Export in progress': 'Export to PDF'}}</small>
          </v-tab> 

        </v-tabs>  

         <v-sheet elevation="1" class="pa-4 mb-4 rounded-lg" color="white">
          <v-row align="center" dense> 
            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="selected_asset"
                :items="all_assets"
                item-text="name"
                item-value="imei"
                label="Select Vehicle"
                prepend-inner-icon="mdi-car-connected"
                outlined
                dense
                hide-details 
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="3">
              <v-menu
                ref="menuFrom"
                v-model="menuu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="from_date"
                    label="From Date"
                    prepend-inner-icon="mdi-calendar-start"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </template>
                <v-date-picker v-model="from_date" @input="menuu = false"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="3">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date"
                    label="To Date"
                    prepend-inner-icon="mdi-calendar-end"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date" @input="menu = false"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="3" class="d-flex">
              <v-btn 
                color="blue" 
                dark 
                block 
                height="40"
                @click="init"
                :loading="isLoading"
              >
                <v-icon left>mdi-magnify</v-icon>
                Search Records
              </v-btn>
            </v-col>

          </v-row>
        </v-sheet>
        <br>

        <v-tabs-items v-model="tabs" v-if="!isLoading" style="background: #eee">  

            <v-tab-item :value="'dashboard'" v-bind:ref="tabs=='dashboard'?'content':'dashboard'">
              <v-simple-table class="pa-2 print-only" v-if="daily_summary.length>0 || raw_points.length>0">
              <template v-slot:default>
                <thead>
                  <tr>
                    <td colspan="5">
                      <h3>Dashboard Report</h3>
                      <h4 class="font-weight-light pt-4"> Asset :{{ asset_name }} </h4>
                      <h4 class="font-weight-light pt-4"> Total Distance:  {{ dashboard_totals.distance.toFixed(1) +'Km' }} </h4>
                      <h4 class="font-weight-light pt-4"> Trips:  {{ dashboard_totals.trips }}  &nbsp;&nbsp; Stoppages:  {{ dashboard_totals.stops }} </h4>
                      <h4 class="font-weight-light pt-4"> Date Range &nbsp;:  {{ from_date }} to {{ date }} </h4>
                    </td>

                    <td colspan="2">
                      <img src="/favicon.png" height="150" width="170"/>
                    </td>
                  </tr>
                  <tr><td colspan="7"> <v-divider></v-divider> </td></tr>
                </thead>
              </template>
              </v-simple-table>
              <ReportDashboard
                :daily="daily_summary"
                :raw-points="raw_points"
              />
            </v-tab-item>

            <v-tab-item :value="'movements'" v-bind:ref="tabs=='movements'?'content':'movements'">
              <div v-if="!isLoading && trip_data.drives.length==0">
              <br>
             <v-alert border="left" color="blue-grey accent-2" colored-border type="info"  elevation="2" > 
               <div class="display-1  font-weight-light">No vehicle movement records available. (select an asset, set the date range and click on the calendar button to fetch records.)</div> 
               </v-alert>  
              </div>

              <br>
              <v-simple-table class="pa-2" v-if="!isLoading && trip_data.drives.length>0">
              <template v-slot:default>
                <thead>
                  <tr>
                    <td colspan="5">
                      <h3>Full Movement Report</h3>
                      <h4 class="font-weight-light pt-4"> Asset :{{ asset_name }} </h4>     
                      <h4 class="font-weight-light pt-4"> Number of Trips:  {{ trip_data.drives.length }} </h4>   
                      <h4 class="font-weight-light pt-4"> Movement Duration:  {{ trip_data.drives_duration }} </h4>
                      <h4 class="font-weight-light pt-4"> Distance Covered:  {{ trip_data.route_length.toLocaleString() +'Km' }} </h4>
                      <h4 class="font-weight-light pt-4"> Date Range &nbsp;:  {{from_date}} to {{date}} </h4> 
                    </td>
                    
                    <td colspan="2">
                      <img src="/favicon.png" height="150" width="170"/>
                    </td>
                  </tr>
                  <tr><td colspan="7"> <v-divider></v-divider> </td></tr>
                  <tr> 
                    <th class="text-left"> Start Date </th>  
                    <th class="text-left">  End Date </th> 
                    <th class="text-left">Duration </th> 
                    <th class="text-left"> Address from</th>  
                    <th class="text-left">  Address to </th>  
                    <th class="text-left"> Top Speed (KPH)</th>  
                    <th class="text-left"> Averag Speed (KPH)</th> 
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(drive,i) in filterrable(trip_data.drives)" :key="i">
                    <td>{{ drive[4] }}</td>  <td>{{ drive[5] }}</td>  <td>{{drive[6]}} </td>  <td>{{ drive[15].from }}</td>  <td>{{drive[15].to}}</td>  <td>{{drive[8]}}</td>
                    <td>{{drive[9]}}</td>  </tr>
                </tbody>
              </template>
            </v-simple-table> 
              <v-pagination v-model="page" v-if="trip_data.drives.length>page_size" :length="round(trip_data.drives.length/page_size)"></v-pagination>
            </v-tab-item>

             <v-tab-item :value="'fuel'" v-bind:ref="tabs=='fuel'?'content':'fuel'">
              <div v-if="!isLoading && trip_data.drives.length==0">
              <br>
             <v-alert border="left" color="blue-grey accent-2" colored-border type="info"  elevation="2" > 
               <div class="display-1  font-weight-light">No vehicle movement records available.</div> 
               </v-alert>  
              </div>

              <br>
              
              <br>
              <v-simple-table class="pa-2" v-if="!isLoading && trip_data.drives.length>0">
               
              <template v-slot:default> 
                <thead>
                  <tr>
                    <td colspan="5">
                      <h3>Fuel Report</h3>
                      <h4 class="font-weight-light pt-4"> Asset :{{ asset_name }} </h4>     
                      <h4 class="font-weight-light pt-4"> Total Fuel Consumed:  {{ trip_data.fuel_consumption.toLocaleString() +'ltrs' }} </h4>
                      <h4 class="font-weight-light pt-4"> Distance Covered:  {{ trip_data.route_length.toLocaleString() +'Km' }} </h4>
                      <h4 class="font-weight-light pt-4"> Date Range &nbsp;:  {{from_date}} to {{date}} </h4> 
                    </td>
                    
                    <td colspan="2">
                      <img src="/favicon.png" height="150" width="170"/>
                    </td>
                  </tr>
                  <tr><td colspan="7"> <v-divider></v-divider> </td></tr>
                  <tr> <th class="text-left"> Start Date </th>  
                  <th class="text-left">  End Date </th> 
                  <th class="text-left">Duration </th> 
                  <th class="text-left"> Address from</th>  <th class="text-left">  Address to </th>    <th class="text-left">Distance (KM)</th> 
                  <th class="text-left"> Fuel consumed (litres)</th> </tr>
                </thead>
                <tbody>
                  <tr v-for="(drive,i) in filterrable(trip_data.drives)" :key="i">
                    <td>{{ drive[4] }}</td>  <td>{{ drive[5] }}</td>  <td>{{drive[6]}} </td>  <td>{{ drive[15].from }}</td>  <td>{{drive[15].to}}</td>   <td>{{drive[7]}}</td> <td>{{drive[10]}}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table> 
              <v-pagination v-model="page" v-if="trip_data.drives.length>page_size" :length="round(trip_data.drives.length/page_size)"></v-pagination>
            </v-tab-item>
 

             <v-tab-item :value="'stops'" v-bind:ref="tabs=='stops'?'content':'stops'">
              <div v-if="!isLoading && trip_data.stops.length==0">
              <br>
             <v-alert border="left" color="blue-grey accent-2" colored-border type="info"  elevation="2" > 
               <div class="display-1  font-weight-light">No vehicle Stoppages records available.</div> 
               </v-alert>  
              </div>

              <br>
              <v-simple-table class="pa-2" v-if="!isLoading && trip_data.stops.length>0">
              <template v-slot:default>
                <thead>
                  <tr>
                    <td colspan="2">
                      <h3>Stoppage Report</h3>
                      <h4 class="font-weight-light pt-4"> Asset :{{ asset_name }} </h4>   
                      <h4 class="font-weight-light pt-4"> Number of Stops:  {{ trip_data.stops.length }} </h4>   
                      <h4 class="font-weight-light pt-4"> Stops Duration:  {{ trip_data.stops_duration }} </h4> 
                      <h4 class="font-weight-light pt-4"> Date Range &nbsp;:  {{from_date}} to {{date}} </h4> 
                    </td>
                    
                    <td colspan="2">
                      <img src="/favicon.png" height="150" width="170"/>
                    </td>
                  </tr>
                  <tr><td colspan="4"> <v-divider></v-divider> </td></tr>
                  <tr> 
                    <th class="text-left"> Start Date </th>  
                    <th class="text-left">  End Date </th> 
                    <th class="text-left">Duration </th> 
                    <th class="text-left"> Address</th>    
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(drive,i) in filterrable(trip_data.stops)" :key="i">
                    <td>{{ drive[6] }}</td>  <td>{{ drive[7] }}</td>  <td>{{drive[8]}} </td>  <td>{{ drive[13] }}</td> 
                  </tr>
                </tbody>
              </template>
            </v-simple-table> 
              <v-pagination v-model="page" v-if="trip_data.stops.length>page_size" :length="round(trip_data.stops.length/page_size)"></v-pagination>
            </v-tab-item>

             <v-tab-item :value="'mileage'" v-bind:ref="tabs=='mileage'?'content':'mileage'">
              <div v-if="!isLoading && trip_data.drives.length==0">
              <br>
             <v-alert border="left" color="blue-grey accent-2" colored-border type="info"  elevation="2" > 
               <div class="display-1  font-weight-light">No vehicle movement records available.</div> 
               </v-alert>  
              </div>

              <br>
              <v-simple-table class="pa-2" v-if="!isLoading && trip_data.drives.length>0">
              <template v-slot:default>
                <thead>
                  <tr>
                    <td colspan="4">
                      <h3>Mileage Report</h3>
                      <h4 class="font-weight-light pt-4"> Asset :{{ asset_name }} </h4>     
                      <h4 class="font-weight-light pt-4"> Total Fuel Consumed:  {{ trip_data.fuel_consumption.toLocaleString() +'ltrs' }} </h4>
                      <h4 class="font-weight-light pt-4"> Distance Covered:  {{ trip_data.route_length.toLocaleString() +'Km' }} </h4>
                      <h4 class="font-weight-light pt-4"> Date Range &nbsp;:  {{from_date}} to {{date}} </h4> 
                    </td>
                    
                    <td colspan="2">
                      <img src="/favicon.png" height="150" width="170"/> 
                    </td>
                  </tr>
                  <tr><td colspan="6"> <v-divider></v-divider> </td></tr>

                  <tr> 
                  <th class="text-left"> Start Date </th>  
                  <th class="text-left">  End Date </th> 
                  <th class="text-left">Duration </th> 
                  <th class="text-left"> Address from</th>  
                  <th class="text-left">  Address to </th>  
                  <th class="text-left"> Distance Covered (KM)</th>  </tr>
                </thead>
                <tbody>
                  <tr v-for="(drive,i) in filterrable(trip_data.drives)" :key="i">
                    <td>{{ drive[4] }}</td>  <td>{{ drive[5] }}</td>  <td>{{drive[6]}} </td>  <td>{{ drive[15].from }}</td>  <td>{{drive[15].to}}</td>  <td>{{drive[7]}}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table> 
             <v-pagination v-model="page" v-if="trip_data.drives.length>page_size" :length="round(trip_data.drives.length/page_size)"></v-pagination>
            </v-tab-item>


            <v-tab-item  :value="'alerts'" v-bind:ref="tabs=='alerts'?'content':'alerts'"> 
               <div v-if="alerts_capped" class="text-caption grey--text pt-2">
                 Alerts are limited to the last 2 days of the selected range.
               </div>
               <div v-if="trip_alert_data.length==0">
                <v-alert border="left" color="blue-grey accent-2" colored-border type="info"  elevation="2" > 
                    <div class="display-1  font-weight-light">No vehicle alert records available.</div> 
                    </v-alert>  
              </div> 

              <br>
              <v-simple-table class="pa-2" v-if="trip_alert_data.length>0">
              <template v-slot:default>
                <thead>
                  <tr>
                    <td colspan="2">
                      <h3>Alerts /  Violations Report</h3>
                      <h4 class="font-weight-light pt-4"> Asset :{{ asset_name }} </h4>     
                      <h4 class="font-weight-light pt-4"> Number of Alerts:  {{ trip_alert_data.length }} </h4> 
                      <h4 class="font-weight-light pt-4"> Date Range &nbsp;:  {{from_date}} to {{date}} </h4> 
                    </td>
                    
                    <td colspan="2">
                      <img src="/favicon.png" height="150" width="170"/>
                    </td>
                  </tr>
                  <tr><td colspan="4"> <v-divider></v-divider> </td></tr>

                  <tr> 
                      <th class="text-left"> Time</th>  
                      <th class="text-left">  Description </th> 
                      <th class="text-left">Address </th> 
                      <th class="text-left"> Speed (KPH)</th>   
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(drive,i) in filterrable(trip_alert_data)" :key="i">
                    <td>{{drive.dt_tracker}}</td>  <td>{{ drive.desc}}</td>  <td>{{drive.current_loc}} </td>  <td>{{ drive.speed }}</td>  
                  </tr>
                </tbody>
              </template> 
              </v-simple-table> 
              <v-pagination v-model="page" v-if="trip_alert_data.length>page_size" :length="round(trip_alert_data.length/page_size)"></v-pagination>
            </v-tab-item> 

        </v-tabs-items>  
      </v-container>

      <!-- Large ranges (> 1 month) are generated in the background and emailed. -->
      <v-dialog v-model="email_dialog" max-width="480" persistent>
        <v-card>
          <v-card-title class="text-h6">Email this report</v-card-title>
          <v-card-text>
            <p class="mb-3">
              The selected range is longer than one month. We will build the report
              (trips, stops and alerts) in the background and email it to you.
            </p>
            <v-text-field
              v-model="report_email"
              label="Email address"
              prepend-inner-icon="mdi-email-outline"
              type="email"
              outlined
              dense
              hide-details
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text :disabled="submitting_report" @click="email_dialog=false">Cancel</v-btn>
            <v-btn color="primary" :loading="submitting_report" @click="submitBackgroundReport">
              Email report
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
</v-app>
</div>
</template>

<script>
import moment from "moment";
import { mapMutations, mapState } from "vuex";
import common from "../mixins/common";
import kensrin_map from "../mixins/kensrin_map";
import Map from "../account/Map"
import DatetimePicker from 'vuetify-datetime-picker' 
import vue from "vue";
import jsPDF from "jspdf";
import html2canvas from "html2canvas" 
import { searchAssets } from "@/services/assetsDb";
import {
  fetchTrips,
  fetchStops,
  fetchAlerts,
  fetchDailySummary,
  fetchRoutePoints,
  watchTripsReport,
  watchStopsReport,
  requestBackgroundReport,
} from "@/services/nodeReports";
import ReportDashboard from "./ReportDashboard";

vue.use(DatetimePicker)

export default {
  name: "Reports",
  mixins: [common ],
  components:{ Map, ReportDashboard },
  computed: {
    ...mapState(["notification", "session" ]),
    // Asset display name for the report headers. `objectsOnly` is declared but
    // never populated in this view (its mixin computed was removed), so the old
    // `objectsOnly.filter(...)[0].name` threw inside the v-simple-table scoped
    // slot and blanked every report table while leaving the pagination visible.
    asset_name() {
      const imei = this.selected_asset ||
        (Array.isArray(this.selected_object) ? this.selected_object[0] : this.selected_object);
      const match = (this.all_assets || []).find(o => o && String(o.imei) === String(imei));
      return (match && (match.name || match.plate_number)) || imei || '';
    },
    // Totals shown in the dashboard report header (same shape as the other tabs).
    dashboard_totals() {
      const t = { distance: 0, trips: 0, stops: 0 };
      for (const d of this.daily_summary) {
        t.distance += Number(d.total_distance_km) || 0;
        t.trips += Number(d.trip_count) || 0;
        t.stops += Number(d.stop_count) || 0;
      }
      return t;
    },
  },
  data() {
    return {
      all_assets: [],
      selected_asset: "",
      objectsOnly: [],
      asset_groups: [],
      top_dash: [],
      m_notification: [],
      trip_data: {
        drives: [],
        events: [],
        stops: []
      },
      tracking_data: [{lat:1.1, lng: 1.1, speed: 200, engineon: true}],
      trip_alert_data: [],
      daily_summary: [],
      raw_points: [],
      tracking_alert_data: [],  
      email_dialog: false,
      report_email: "",
      submitting_report: false,
      from_date: moment().subtract(7,'days').format("YYYY-MM-DD HH:mm"),  
      date: moment().format("YYYY-MM-DD HH:mm"), 
      isLoading: false, 
      report_watcher: null,
      // Signature of the dataset currently held for each provider, so switching
      // between tabs (or re-searching) only fetches what is missing.
      loaded_tabs: {},
      has_searched: false,
      loading_dataset: null,
      page: 1, 
      page_size: 10,
      menu: false,
      downloading: false,
      menuu: false,
      modal: false,
      tabs: null, 
      selected_object:  this.$store.state.selected_object 
    };
  },
  created() {
    // this.available_data();
  }, 
  async mounted() {   
    this.all_assets = await searchAssets(this.session.account[0].username);
    this.selected_asset = this.selected_object[0];
    // Auto-load once the asset is populated instead of waiting for a manual
    // "Search Records" click. init() also guards the range and the >1-month
    // background-email path, and load_tab only fetches what is not cached.
    if (this.selected_asset) {
      if (!this.tabs) this.tabs = "dashboard";
      this.init();
    }
  },
  beforeDestroy() {
    if (this.report_watcher) this.report_watcher();
  },
  methods: {
    filterrable(array){ 
      var new_array = [];  
      for(var i = this.page_size * (this.page -1); i < this.page * this.page_size; i++ ){
        if(i>=array.length)
          break;
        new_array.push(array[i]); 
      } 
      return new_array;
    },
    round(data){
      return Math.ceil(data);
    },
    init(){
      if(this.selected_asset !=null && this.selected_asset !=""){
        // Ranges longer than a month are generated in the background and
        // emailed, rather than fetched inline.
        if (this.rangeExceedsOneMonth()) {
          // Make sure a stale short-range search can't trigger an inline fetch
          // when the user switches tabs.
          this.has_searched = false;
          this.loaded_tabs = {};
          this.stop_report_watcher();
          this.email_dialog = true;
          return;
        }
        // A fresh search invalidates every cached dataset and loads only the
        // data for the tab that is currently visible.
        this.loaded_tabs = {};
        this.top_dash = [];
        this.has_searched = true;
        this.stop_report_watcher();
        this.load_tab(this.tabs || "dashboard");
      } else alert("Please select asset first.");
    },

    rangeExceedsOneMonth() {
      const from = moment(this.from_date);
      const to = moment(this.date);
      return to.diff(from, "months", true) > 1;
    },

    // Queue a background report for the selected asset/range and email it.
    async submitBackgroundReport() {
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.report_email)) {
        alert("Please enter a valid email address.");
        return;
      }
      this.submitting_report = true;
      try {
        const res = await requestBackgroundReport({
          imei: this.selected_asset,
          from: this.from_date,
          to: this.date,
          email: this.report_email,
        });
        if ((res.data && res.data.status === "ok") || res.status === 200) {
          this.email_dialog = false;
          alert(
            (res.data && res.data.message) ||
              "Your report has been queued and will be emailed to " + this.report_email + "."
          );
        } else {
          alert(res.payload || "Could not queue the report. Please try again.");
        }
      } finally {
        this.submitting_report = false;
      }
    },

    // Alerts are capped to the last 2 days of the selected range: geocoding a
    // long window is what makes the request expensive.
    alerts_range() {
      const to = moment(this.date);
      const from = moment(this.from_date);
      const cappedFrom = to.diff(from, "days", true) > 2 ? to.clone().subtract(2, "days") : from;
      return { from: cappedFrom.format("YYYY-MM-DD"), to: to.format("YYYY-MM-DD") };
    },

    initDownload(source){
      if (this.downloading) {
        alert("Another process is already running. Please wait for download to complete.");
        return;
      }
      this.downloadWithCSS(source);
    },

    // Capture the active tab as one image and slice it across A4 pages. The
    // whole table is rendered first (huge page_size) so the PDF is complete.
    async downloadWithCSS(source) {
      this.downloading = true;
      const previousPageSize = this.page_size;
      this.page_size = 10000000000;
      try {
        // Let Vue render every row, then give the browser a frame to lay it out
        // (html2canvas captures what is actually painted).
        await this.$nextTick();
        await new Promise((resolve) => setTimeout(resolve, 60));

        const tabItem = this.$refs.content;
        const input = tabItem && tabItem.$el;
        if (!input) throw new Error("Nothing to export on this tab.");

        const SCALE = 2;
        // Browsers cap the canvas area (~16k x 16k). Bail loudly rather than
        // hand html2canvas a size that silently renders blank.
        if (input.scrollWidth * SCALE * input.scrollHeight * SCALE > 2.4e8) {
          throw new Error("This report is too large to export as one PDF. Narrow the date range.");
        }

        const canvas = await html2canvas(input, {
          scale: SCALE,
          useCORS: true,
          backgroundColor: "#ffffff",
          // The dashboard report header is `print-only` (hidden on screen).
          // Reveal it in the cloned document html2canvas renders so it shows
          // up in the PDF only, with no flash on the live view.
          onclone: (clonedDoc) => {
            clonedDoc.querySelectorAll(".print-only").forEach((el) => {
              el.style.display = "block";
            });
          },
        });
        const imgData = canvas.toDataURL("image/jpeg", 0.92);

        const pdf = new jsPDF("p", "mm", "a4");
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const imgWidth = pageWidth;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        // Draw the full-height image once per page, shifted up by exactly one
        // page each time, so page N shows image rows [N*pageHeight, ...]. The
        // old `position += heightLeft - imgHeight` drifted and left pages 3+
        // blank (and dropped content) for reports taller than two pages.
        let offset = 0;
        pdf.addImage(imgData, "JPEG", 0, offset, imgWidth, imgHeight);
        offset += pageHeight;
        while (offset < imgHeight) {
          pdf.addPage();
          pdf.addImage(imgData, "JPEG", 0, -offset, imgWidth, imgHeight);
          offset += pageHeight;
        }

        pdf.save(source + "_report.pdf");
      } catch (error) {
        console.error("PDF export failed", error);
        alert("Could not export the PDF. " + ((error && error.message) || "Please try again."));
      } finally {
        // Always restore state, otherwise a failed capture left the button stuck
        // on "Export in progress" and page_size at 1e10 (no pagination anywhere).
        this.downloading = false;
        this.page_size = previousPageSize || 10;
      }
    },
 
    // Which backend dataset each tab needs. movements/mileage/fuel share the
    // trip rows, so loading one satisfies the other two.
    dataset_for(tab) {
      if (tab === "dashboard") return "dashboard";
      if (tab === "stops") return "stops";
      if (tab === "alerts") return "alerts";
      return "trips";
    },

    range_signature() {
      return [this.selected_asset, this.from_date, this.date].join("|");
    },

    // Loads only the data required by `tab`, from the Node API, and skips the
    // request entirely when the same asset/date range is already cached.
    async load_tab(tab) {
      if (!this.selected_asset) return;
      const dataset = this.dataset_for(tab);
      const signature = this.range_signature() + "|" + dataset;
      if (this.loaded_tabs[dataset] === signature) return;
      if (this.loading_dataset === dataset) return;

      this.loading_dataset = dataset;
      this.isLoading = true;
      try {
        let ok;
        if (dataset === "trips") ok = await this.load_trips_data();
        else if (dataset === "stops") ok = await this.load_stops_data();
        else if (dataset === "dashboard") ok = await this.load_dashboard_data();
        else ok = await this.load_alerts_data();
        if (ok) this.loaded_tabs[dataset] = signature;
      } finally {
        this.isLoading = false;
        this.loading_dataset = null;
      }
    },

    // Daily rollup + raw history points power the dashboard charts.
    async load_dashboard_data() {
      const imei = this.selected_asset;
      const fromDay = moment(this.from_date).format("YYYY-MM-DD");
      const toDay = moment(this.date).format("YYYY-MM-DD");

      const summary = await fetchDailySummary({ imei, from: fromDay, to: toDay }).catch(() => ({ status: 500 }));

      // Raw points are capped by the server (10k); they feed the speed histogram.
      const route = await fetchRoutePoints({
        imei,
        dtf: moment(this.from_date).startOf("day").format("YYYY-MM-DD HH:mm:ss"),
        dtt: moment(this.date).endOf("day").format("YYYY-MM-DD HH:mm:ss")
      });

      if (summary && summary.status === 200) this.daily_summary = summary.data || [];
      if (route && route.status === 200) this.raw_points = Array.isArray(route.data) ? route.data : [];

      return summary && summary.status === 200;
    },

    async load_trips_data() {
      const res = await fetchTrips({
        imei: this.selected_asset,
        from: this.from_date,
        to: this.date
      });
      if (this.report_failed(res)) return false;

      // Merge so the trip totals refresh without clearing an already-loaded
      // stoppages dataset.
      const merged = { ...this.trip_data, ...res.data };
      merged.stops = this.trip_data.stops;
      merged.stops_duration = this.trip_data.stops_duration;
      this.trip_data = merged;
      this.watch_summary_updates("trips");
      return true;
    },

    async load_stops_data() {
      const res = await fetchStops({
        imei: this.selected_asset,
        from: this.from_date,
        to: this.date
      });
      if (this.report_failed(res)) return false;

      this.trip_data = {
        ...this.trip_data,
        stops: res.data.stops,
        stops_duration: res.data.stops_duration
      };
      this.watch_summary_updates("stops");
      return true;
    },

    async load_alerts_data() {
      const range = this.alerts_range();
      const res = await fetchAlerts({
        imei: this.selected_asset,
        from: range.from,
        to: range.to
      });
      if (this.report_failed(res, false)) return false;

      this.trip_alert_data = (res.data || []).map(h => ({
        lat: h.lat,
        lng: h.lng,
        speed: h.speed,
        engineon: true,
        // Server reverse-geocodes report alerts; fall back to coordinates when
        // a row has no address (e.g. geocoder unavailable).
        current_loc: h.loc || this.coord_label(h.lat, h.lng),
        dt_tracker: h.dt_tracker,
        reg: h.name,
        desc: h.event_desc
      }));
      return true;
    },

    coord_label(lat, lng) {
      const a = Number(lat);
      const b = Number(lng);
      if (!isFinite(a) || !isFinite(b)) return "";
      return a.toFixed(5) + ", " + b.toFixed(5);
    },

    report_failed(res, tooManyMessage) {
      if (res && res.status === 200) return false;
      if (tooManyMessage !== false) {
        alert("Failed to generate, number of records for the specied dates is too much. Please select a shorter date range.");
      }
      return true;
    },

    stop_report_watcher() {
      if (this.report_watcher) {
        this.report_watcher();
        this.report_watcher = null;
      }
    },

    // The summaries behind the report are built by the aggregator worker, so an
    // early reply can still be catching up. Poll only the dataset in view.
    watch_summary_updates(dataset) {
      const self = this;
      this.stop_report_watcher();
      const params = {
        imei: this.selected_asset,
        from: this.from_date,
        to: this.date
      };

      if (dataset === "stops") {
        this.report_watcher = watchStopsReport(params, function (data) {
          self.trip_data = {
            ...self.trip_data,
            stops: data.stops,
            stops_duration: data.stops_duration
          };
        });
      } else {
        this.report_watcher = watchTripsReport(params, function (data) {
          const merged = { ...self.trip_data, ...data };
          merged.stops = self.trip_data.stops;
          merged.stops_duration = self.trip_data.stops_duration;
          self.trip_data = merged;
        });
      }
    }
  },
  computed: {
      dateRangeText () {
        return this.dates.join(' to ')
      },
      // True when the selected range is longer than the 2-day alerts window.
      alerts_capped () {
        return moment(this.date).diff(moment(this.from_date), "days", true) > 2;
      },
    },
  watch: {
    tabs(newTab) {
      this.page = 1;
      // Pull only the dataset this tab needs, the first time it is opened.
      if (this.has_searched && newTab) this.load_tab(newTab);
    },
    "$store.state.selected_object": function() {
      this.selected_asset = this.selected_object[0];
      this.tracking_alert_data = [];
      this.tabs = "dashboard";
      this.init() 
    },
    page_size:function(old,newwer){
      
    }
  }
};
</script>

<style scoped>
#dashboard,
template {
  background: #e7e7e7;
}
/* Report headers that must appear in the exported PDF but not on screen.
   html2canvas reveals them inside its cloned document (see downloadWithCSS). */
.print-only {
  display: none;
}
</style>
